export enum CmrStatus {
    Unknown = 0,
    Valid = 1,
    Missing = 2,
    NotRequired = 3
}
